import * as React from 'react';

import { cn } from '../../lib/utils';
import { Label } from '../ui/label';

export interface FormFieldProps {
  /** Omit for placeholder-first fields; panel titles often supply context. */
  label?: string;
  htmlFor?: string;
  description?: string;
  error?: string;
  required?: boolean;
  className?: string;
  children: React.ReactNode;
}

export function FormField({
  label,
  htmlFor,
  description,
  error,
  required,
  className,
  children,
}: FormFieldProps) {
  return (
    <div className={cn('space-y-1.5', className)}>
      {label ? (
        <Label htmlFor={htmlFor}>
          {label}
          {required ? <span className="text-destructive"> *</span> : null}
        </Label>
      ) : null}
      {children}
      {description && !error ? (
        <p className="text-caption text-muted-foreground">{description}</p>
      ) : null}
      {error ? <p className="text-caption text-destructive">{error}</p> : null}
    </div>
  );
}
